import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import {
  CircleIconBoxWithTitle,
  DiscountedPrice,
  CircleIcon,
  CircleCheckIcon,
} from '../wmw/WmwComp';
import monitor from '../img/circle-monitor.png';
import shield from '../img/circle-shield.png';
import notebook from '../img/circle-notebook.png';
import { ChurchschoolPrices } from '../../homeschool/ChurchschoolPriceContext';

const HFHJSection10 = ({ prices }: { prices: ChurchschoolPrices }) => {
  const { main, sub } = prices.hfhj;
  return (
    <>
      <section className="bg-[#F9F9F9] p-3 py-10 md:pt-20">
        <div className="m-auto flex w-full max-w-[520px] flex-col items-center justify-center gap-5 md:gap-10">
          <div className="mb-5 text-center font-['Pretendard'] text-3xl font-extrabold text-[#FE7020] md:text-4xl">
            프로그램 구성&가격
          </div>

          <div
            className="relative flex w-full flex-col items-center justify-center gap-5 rounded-lg bg-white p-5 md:gap-10"
            style={{
              boxShadow: '0px 3px 7px 1px rgba(150,150,150,0.3 )',
            }}
          >
            <div className="absolute left-1/2 top-0 w-fit -translate-x-1/2 -translate-y-1/2 rounded-xl border-2 border-[#FE7020] bg-white px-5 py-2 text-xl font-extrabold text-[#FE7020] shadow md:px-7 md:py-3 md:text-2xl">
              교사 메인 코스
            </div>

            <div className="mt-5 w-fit rounded-full border border-[#FE7020] bg-white px-4 py-1 text-base text-[#FE7020] md:mt-10 md:px-6 md:py-2 md:text-xl">
              <span className="font-bold">교사 코스</span> (메인-2년)
            </div>
            <div className="flex w-full items-center justify-center gap-5 md:gap-7">
              {/* <div className="grid grid-cols-3 w-full place-items-center gap-5 md:gap-7"> */}
              <CircleIconBoxWithTitle
                icon={monitor}
                circleColor="bg-[#FFDA19]"
                circleSize="h-20 w-20 md:h-28 md:w-28"
                title={
                  <div className="whitespace-nowrap text-sm md:text-xl">
                    온라인 교육과정
                  </div>
                }
                delay={0.1}
              />
              <CircleIconBoxWithTitle
                icon={shield}
                circleColor="bg-[#FFDA19]"
                circleSize="h-20 w-20 md:h-28 md:w-28"
                title={
                  <div className="whitespace-nowrap text-sm md:text-xl">
                    온라인 자료{' '}
                    <span className="font-bold text-[#FE7020]">2년</span>
                  </div>
                }
                delay={0.3}
              />
              <CircleIconBoxWithTitle
                icon={notebook}
                circleColor="bg-[#FFDA19]"
                circleSize="h-20 w-20 md:h-28 md:w-28"
                title={
                  <div className="whitespace-nowrap text-sm md:text-xl">
                    교재 <span className="font-bold text-[#FE7020]">2년치</span>
                  </div>
                }
                delay={0.5}
              />
            </div>

            <DiscountedPrice
              price={main.original}
              discountedPrice={main.discount}
              discountColor="text-[#FE7020]"
            />
          </div>

          <CircleIcon color="#FE7020" text="+" />
          <div className="m-auto w-fit rounded-2xl border-2 border-[#FE7020] bg-white px-5 py-2 text-2xl font-extrabold text-[#FE7020] shadow-md md:px-8 md:py-3 md:text-3xl">
            학생용 교재 구성
          </div>
          <Accordion title="[교재] 구성" color="#FE7020">
            <BookDetail />
          </Accordion>
        </div>
      </section>
    </>
  );
};

const Accordion = ({
  color,
  title,
  children,
}: {
  color: string;
  title: string;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <div
      className="cursor-pointer rounded-2xl p-3"
      onClick={() => setIsOpen((v) => !v)}
      style={{ backgroundColor: color }}
    >
      <div className="flex w-full items-center text-[#FFDA19]">
        <ChevronDownIcon
          className={`w-6 transform transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : 'rotate-0'}`}
        />
        {/* <ChevronDownIcon className="w-6 flex-shrink-0" /> */}
        {!isOpen && (
          <div className="w-full flex-1 items-center justify-center text-center font-bold md:text-lg">
            {title}
          </div>
        )}
      </div>
      <motion.div
        className="overflow-hidden"
        initial={false}
        animate={{ height: isOpen ? 'auto' : 0 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

const BookDetail = () => {
  return (
    <div className="m-auto flex cursor-auto flex-col items-center gap-5 px-5 py-10">
      <div className="rounded-full border-[1px] border-[#FFDA19] px-5 py-1 text-lg font-bold text-[#FFDA19] md:text-xl">
        Hello, Father! Hello, Jesus!
      </div>
      <div className="text-xl font-extrabold text-white md:text-2xl">
        커리큘럼 구성
      </div>
      <div className="flex flex-col gap-5">
        <div className="flex w-full gap-2 text-base font-bold text-white md:text-lg">
          <CircleCheckIcon width="22" />
          본교재 2권(Part 1,2)
        </div>
        <div className="flex w-full gap-2 text-base font-bold text-white md:text-lg">
          <CircleCheckIcon width="22" /> 워크북 1권
        </div>
        <div className="flex w-full gap-2 text-base font-bold text-white md:text-lg">
          <CircleCheckIcon width="22" /> QR 스티커(찬양 및 워크북)
        </div>
        <div className="flex w-full gap-2 text-base font-bold text-white md:text-lg">
          <CircleCheckIcon width="22" /> 스토리북 1권
        </div>
        <div className="flex w-full gap-2 text-base font-bold text-white md:text-lg">
          <CircleCheckIcon width="22" /> 젭스플 제공
        </div>
      </div>
      <div className="w-full rounded-lg bg-white py-3 text-center text-xl font-bold text-black sm:w-[80%] md:text-2xl">
        <div className="text-sm">HF/HJ 각각</div>
        판매가 87,000원 / 1년
      </div>
      <div className="text-sm text-white md:px-10">
        * 최초 교사 수료 후 수료 후기 작성 시 학생용 교재 5세트 이상 구매 시 25%
        할인 혜택이 적용됩니다.
      </div>
    </div>
  );
};

export default HFHJSection10;
